<!-- 由 suu 创建于 2021-08-12 星期四 -->
<template>
  <div class="CourseItem" @click="onAppoint">
    <!-- 头像 -->
    <div class="ci-img" @click="handleHeadBox">
      <img
        class="img"
        :src="info.image + '?x-oss-process=image/resize,m_fill,h_250,w_250'"
        alt=""
      />
      <img
        v-if="isZqj"
        class="niunian"
        src="https://cdnvue.gymcity.com.cn/uploads/24zqj-txk"
      />
      <!-- 萌新导师标签 -->
      <div class="mx-guid-tag" v-if="info.is_guidance == 1">
        <i class="iconfont iconaccount-fill"></i>
        教练导师
      </div>
      <!-- 萌新导师解释弹窗 -->
      <img
        class="mx-guid-pop"
        v-if="showMxPopId == info.coachid"
        :src="`https://cdnvue.gymcity.com.cn/uploads/subc-mx-pop?v=1`"
        alt=""
      />
    </div>
    <div class="ci-info">
      <div class="i-name">
        {{ info.name }}
        <!-- <span
          class="coach-prove"
          @click.stop="handelDoubleCodePop(info.coachid)"
          v-if="hasCoachProve(info.coachid)"
        >
          <span class="prove-icon">阴</span>
          健康证明
        </span> -->
        <img
          v-if="info.is_postpartum != '0'"
          class="name-icon-yun user-btn"
          @click.stop="pzPop(2)"
          src="https://cdnvue.gymcity.com.cn/uploads/pub-cocah-tag-yun"
          alt=""
        />
        <!-- 拍 -->
        <img
          v-if="info.is_photo != '0'"
          @click.stop="pzPop(1)"
          class="name-icon-img user-btn"
          src="https://cdnvue.gymcity.com.cn/uploads/pub-25jlpp-icon"
          alt=""
        />
      </div>
      <div class="i-label">
        <span
          class="label-item"
          v-for="(item, index) in getFeature(info.feature)"
          :key="index"
          ><span class="item-text">{{ item }}</span
          ><span
            class="item-icon"
            v-if="index < getFeature(info.feature).length - 1"
            >/</span
          ></span
        >
      </div>
      <div class="i-time">
        课程时间：{{ info.coursestarttime.slice(11, 16) }}-{{
          info.courseendtime.slice(11, 16)
        }}
      </div>
    </div>
    <div class="ci-class">
      <div class="c-title">待约课时</div>
      <div class="c-num">
        {{ info.left }}
      </div>
    </div>
    <div class="ci-btn user-btn" :class="{ 'ci-btn-off': info.left <= 0 }">
      {{ info.left > 0 ? '预约' : '已满' }}
    </div>
    <!-- 孕产 拍照 弹窗 -->
    <GymPopup
      :cur="showPzPop"
      @boxClose="showPzPop = 0"
      v-if="showPzPop"
    ></GymPopup>
    <!-- 2023抗原弹窗 -->
    <DoubleCodePop
      :visible.sync="showDoubleCodePop"
      :doubleCodePopInfo="doubleCodePopInfo"
      @boxClose="showDoubleCodePop = false"
    ></DoubleCodePop>
    <!-- 专属训练规划师弹窗 -->
  </div>
</template>

<script>
import GymPopup from '@/components/GymPopup'
import DoubleCodePop from './DoubleCodePop.vue'

export default {
  name: 'CourseItem',

  components: { GymPopup, DoubleCodePop },

  props: {
    isZqj: {},
    info: {},
    showMxPopId: {},
    coachTestList: {}
  },

  data() {
    return {
      showPzPop: 0, // 显示拍 孕弹窗
      showDoubleCodePop: false,
      doubleCodePopInfo: {}
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    getFeature(feature) {
      return feature
        .replace(/[\/\\]/g, '/')
        .split('/')
        .slice(0, 3)
    },
    // 点击教练头像区域
    handleHeadBox(e) {
      if (this.info.is_guidance === 1) {
        this.$emit('head-click', this.info.coachid)
        e.stopPropagation()
      }
    },
    /**
     * 点击预约
     */
    onAppoint() {
      this.$emit('appoint')
      // if (this.info.left > 0) this.$emit('appoint')
    },
    /**
     * 显示拍 孕 弹窗
     */
    pzPop(i) {
      this.showPzPop = i
    },
    // 处理月/日的显示格式
    _handleDate(date) {
      return ('00' + date).slice(String(date).length)
    },
    // 判断教练是否有抗原检测
    hasCoachProve(cid) {
      return this.coachTestList.find((v) => v.cid === cid * 1)
    },
    // 推荐教练判断双码 显示双码弹窗
    handelDoubleCodePop(cid) {
      const obj = this.hasCoachProve(cid)
      this.showDoubleCodePop = true
      this.doubleCodePopInfo = obj
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.CourseItem {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 6.4vw;
  color: #000;
  .ci-img {
    position: relative;
    .img {
      width: 18vw;
      height: 18vw;
      background-color: #d8d8d8;
      border-radius: 9.3vw;
      object-fit: cover;
    }
    .niunian {
      width: vw(74);
      height: vw(74);
      position: absolute;
      top: vw(-3);
      left: vw(-3);
      z-index: 8;
    }
    .mx-guid-tag {
      display: flex;
      align-items: center;
      justify-content: center;
      width: vw(62);
      height: vw(16);
      border-radius: vw(4);
      color: #fff;
      background-color: #dc0050;
      font-size: vw(10);
      font-weight: 600;
      position: absolute;
      bottom: vw(-3);
      left: 50%;
      transform: translateX(-50%);
      // z-index: 9;
      i {
        font-size: vw(10);
        margin-top: vw(-2);
      }
    }
    .mx-guid-pop {
      width: vw(313);
      position: absolute;
      top: -40vw;
      left: -9vw;
      z-index: 9;
    }
  }
  .ci-info {
    margin-left: 2.7vw;
    flex: 1;
    .i-name {
      font-size: 4vw;
      font-weight: 600;
      display: flex;
      align-items: center;
      .name-icon-yun {
        height: 4.8vw;
        width: auto;
        margin-left: 2.1vw;
      }
      .name-icon-img {
        width: 4.8vw;
        height: auto;
        margin-left: 1.2vw;
        border-radius: 1.2vw;
      }
      .coach-prove {
        margin-left: vw(8);
        display: flex;
        align-items: center;
        font-size: vw(11);
        font-weight: 500;
        color: #676fa7;
        .prove-icon {
          margin-right: vw(4);
          font-size: vw(9);
          font-weight: 600;
          color: #ffffff;
          width: vw(13);
          height: vw(13);
          background: linear-gradient(180deg, #b0dafd 0%, #819dfa 100%);
          border-radius: vw(4);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: vw(-2);
        }
      }
    }
    .i-label {
      display: flex;
      align-items: center;
      margin-top: 1.1vw;
      .label-item {
        font-size: 2.7vw;
        font-weight: 450;
        color: rgba(0, 0, 0, 0.49);
        display: flex;
        align-items: center;
        justify-content: center;
        .item-icon {
          margin: 0 vw(3);
        }
      }
    }
    .i-time {
      margin-top: 1.1vw;
      font-size: 3.2vw;
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .ci-class {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-left: 2.1vw;
    .c-title {
      font-size: 2.7vw;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.5);
    }
    .c-num {
      margin-top: 1.3vw;
      width: 6vw;
      height: 7.2vw;
      background-color: #f7f7f7;
      border-radius: 1.1vw;
      border: solid 0.3vw #f1f1f1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 4vw;
      font-weight: 600;
    }
  }
  .ci-btn {
    font-size: 3.5vw;
    font-weight: 600;
    color: #f04646;
    margin-left: 5.3vw;
  }
  .ci-btn-off {
    color: #d8d8d8;
  }
}
</style>
